export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/spoof-regular-001c604bd31e45b08a94363c3ac6ede7.woff2";